export class FieldValidationItem {
    public isRequired = false;
    public isVisible = false;
    public isEditable = false;
}
